import { useLocations } from "@/hooks/useLocations";

const LocationsSection = () => {
  const { data: locations, isLoading } = useLocations(true);
  const displayLocations = locations?.slice(0, 5) ?? [];

  return (
    <section id="locations" className="py-16 md:py-24 bg-brand-gradient">
      <div className="px-6 md:px-16">
        <div className="text-center mb-16">
          <h2 className="font-open-sans font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-primary-foreground mb-4">Explore Top Locations</h2>
          <p className="font-body text-sm text-primary-foreground/80 max-w-xl mx-auto">
            Find your dream home in Kenya's most sought-after residential areas.
          </p>
        </div>

        {isLoading ? (
          <p className="text-center text-primary-foreground/60 font-body">Loading locations...</p>
        ) : displayLocations.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {displayLocations.slice(0, 2).map((loc) => (
                  <LocationCard key={loc.id} image={loc.image} name={loc.name} area={loc.area} count={loc.property_count} href={`/locations/${loc.slug}`} />
                ))}
              </div>
            </div>
            {displayLocations[2] && (
              <div className="lg:row-span-2">
                <LocationCard image={displayLocations[2].image} name={displayLocations[2].name} area={displayLocations[2].area} count={displayLocations[2].property_count} href={`/locations/${displayLocations[2].slug}`} />
              </div>
            )}
            <div className="lg:col-span-2">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {displayLocations.slice(3).map((loc) => (
                  <LocationCard key={loc.id} image={loc.image} name={loc.name} area={loc.area} count={loc.property_count} href={`/locations/${loc.slug}`} />
                ))}
              </div>
            </div>
          </div>
        ) : (
          <p className="text-center text-primary-foreground/60 font-body">No locations available yet.</p>
        )}

        <div className="text-center mt-12">
          <a href="/locations" className="inline-block font-body text-xs tracking-[0.25em] uppercase bg-accent text-accent-foreground px-10 py-4 hover:bg-foreground hover:text-background transition-colors duration-300">
            Explore All Locations
          </a>
        </div>
      </div>
    </section>
  );
};

const LocationCard = ({
  image,
  name,
  area,
  count,
}: {
  image: string;
  name: string;
  area: string;
  count: string;
}) => (
  <a
    href="/locations"
    className="group relative aspect-[16/10] rounded-xl overflow-hidden block"
  >
    <img
      src={image}
      alt={`${name}, ${area}`}
      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
      loading="lazy"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-foreground/90 via-foreground/20 to-transparent" />
    
    {/* Property count badge */}
    <div className="absolute top-4 right-4 bg-accent text-accent-foreground px-3 py-1 rounded-full font-body text-xs font-medium">
      {count} Properties
    </div>

    {/* Location name */}
    <div className="absolute bottom-6 left-6">
      <h3 className="font-display text-2xl md:text-3xl font-light text-primary-foreground">
        {name}
      </h3>
    </div>
  </a>
);

export default LocationsSection;
